module.exports = __webpack_public_path__ + "img/icn_circle_planning_table.6aa51e6e.svg";